import { render, staticRenderFns } from "./historicoAtendimentoMensagens.vue?vue&type=template&id=5ff26faa"
import script from "./historicoAtendimentoMensagens.ts?vue&type=script&lang=js&external"
export * from "./historicoAtendimentoMensagens.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff26faa')) {
      api.createRecord('5ff26faa', component.options)
    } else {
      api.reload('5ff26faa', component.options)
    }
    module.hot.accept("./historicoAtendimentoMensagens.vue?vue&type=template&id=5ff26faa", function () {
      api.rerender('5ff26faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/atendimento/historicoAtendimentoMensagens/historicoAtendimentoMensagens.vue"
export default component.exports